import { useSelector } from 'react-redux';
import { Divider } from '@material-ui/core';
import { withTheme } from '@material-ui/styles';
import React, { useEffect, useState } from 'react';
import ChevronRightOutlinedIcon from '@material-ui/icons/ChevronRightOutlined';
import Page from 'components/Page';
import EditModal from './editModal';
import Row from '../../components/Row';
import { useActions } from 'helpers/useActions';
import { Container } from 'components/Container';
import ForumPostCard from './postCard/ForumPostCard';
import NewForumPost from './newForumPost/NewForumPost';
import { getForumPostsAction, getSubjects } from './actions';
import FullScreenLoader from 'components/Loaders/FullScreenLoader';
import { ForumCard, CategoriesList, Category, Post } from './styled';
import LoginAlertModal from '../../components/loginModal/LoginAlertModal';
import Modal, { useModal } from 'components/Modal';
import HeaderBanner from 'components/headerBanner/HeaderBanner';
import { PrimaryButton } from 'components/Buttons/PrimaryButton';

function Forum({ history }) {
  const getForumPosts = useActions(getForumPostsAction);
  const getCategories = useActions(getSubjects);
  const [editForum, setEditForum] = useState(false);
  const [selectedForum, selectForum] = useState(null);

  const modal = useModal();

  const authUser = useSelector(state => state.authState.firestoreUser);
  const auth = useSelector(state => state.authState.authenticated);
  const ps = useSelector(state => state.forumState.posts);
  const loading = useSelector(state => state.forumState.loading);
  const categories = useSelector(state => state.forumState.subjects);

  const [category, setCategory] = useState(-1);
  const [posts, setPosts] = useState(ps);
  const [date, setDate] = useState([]);
  let d = [];

  useEffect(() => {
    if (Object.keys(posts).length < 1) {
      getForumPosts();
    }
    getCategories();

    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (ps) {
      if (category !== -1 && ps) {
        let filteredPosts = {};
        Object.values(ps).map(post => {
          if (post.subject === categories[category].name) {
            filteredPosts[post.key] = post;
          }
          // return null;
        });
        setPosts({ ...filteredPosts });
      } else {
        setPosts(ps);
      }
      Object.values(ps).map(post => {
        d.push(post.date);
      });
      setDate(d);
    } else {
      setPosts(ps);
    }
  }, [ps, category, categories]);

  function handleClose() {
    setEditForum(false);
  }

  function onEdit(forum) {
    selectForum(forum);
    setEditForum(true);
  }

  const postsNumber = posts => {
    if (Object.keys(posts)) {
      return Object.keys(posts)
        .reverse()
        .map(postKey => (
          <ForumPostCard
            onEdit={() => onEdit(posts[postKey])}
            post={posts[postKey]}
            key={postKey}
            push={() => history.push('/forum/' + postKey)}
            anon={authUser.anon || false}
            history={history}
          />
        ));
    }
  };

  const handleOnClick = () => {
    modal.close();
  };

  const highlightAfterClick = (i, cat) => {
    // setColor('#1abc9c');
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-start',
          alignItems: 'center',
          color: '#1abc9c'
        }}
      >
        <ChevronRightOutlinedIcon />
        {checkLength(cat.name)}
      </div>
    );
  };

  const checkLength = string => {
    if (string.length > 15) {
      return string.substring(0, 12) + '......';
    }
    return string;
  };

  if (loading) return <FullScreenLoader />;
  return (
    <React.Fragment>
      <HeaderBanner
        title="Forum"
        subtitle="Ask and get all information you need."
      />
      {/* // TODO: Needed to do after some time */}
      {/* <TopicManager>
        <TopicSorting />
        <SearchPart placeholder="Search Topics" />
        <StartTopic />
      </TopicManager> */}
      <Page>
        <Container>
          <Post>
            {auth && (
              <ForumCard maxwidth={'900'}>
                <NewForumPost />
              </ForumCard>
            )}
            {postsNumber(posts)}
            <Row justify="center">
              <PrimaryButton
                onClick={() => getForumPosts(Math.min(...date), posts)}
              >
                Next
              </PrimaryButton>
            </Row>
          </Post>
          <CategoriesList>
            <span
              style={{
                display: 'flex',
                fontSize: '1rem',
                justifyContent: 'center',
                alignItems: 'center',
                height: '3em',
                color: 'black'
              }}
            >
              Search By Categories
            </span>
            <Divider />

            <div
              style={{
                marginTop: '1em'
              }}
            >
              {categories.map((cat, i) => {
                return (
                  <Category onClick={() => setCategory(i)} key={cat.name}>
                    <Row justify="space-between" align="center">
                      <div
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-start',
                          alignItems: 'center'
                        }}
                      >
                        {category === i ? (
                          highlightAfterClick(i, cat)
                        ) : (
                          <React.Fragment>
                            <ChevronRightOutlinedIcon />
                            {checkLength(cat.name)}
                          </React.Fragment>
                        )}
                      </div>

                      <div>
                        <button
                          style={{
                            marginRight: '20px',
                            backgroundColor: '#a1a8ad',
                            width: '40px',
                            borderRadius: '5px',
                            border: 'none',
                            color: 'white'
                          }}
                        >
                          {`${cat.postCount || 0}`}
                        </button>
                      </div>
                    </Row>
                  </Category>
                );
              })}
            </div>
          </CategoriesList>
        </Container>
      </Page>
      <EditModal
        open={editForum}
        forum={selectedForum}
        handleClose={handleClose}
      />
      <Modal {...modal.props}>
        <React.Fragment>
          <LoginAlertModal onClick={handleOnClick} history={history} />
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
}

export default withTheme(Forum);
